module.exports = __webpack_public_path__ + "static/media/dakika-icon.33106e3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/asset/img/dakika-icon.png
// module id = 1238
// module chunks = 0